import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-signout.tsx
/**
* icon.24.signout
*
* Keywords: exit, logout, door, arrow, right, leave, egress, departure
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNTUzIDUuMTA1QTEgMSAwIDAgMSAxMiA2djFoMWExIDEgMCAwIDEgMSAxdjIuMDA0YS41LjUgMCAwIDEtMSAwVjhoLTF2OGgxdi0xLjk5NmEuNS41IDAgMSAxIDEgMFYxNmExIDEgMCAwIDEtMSAxaC0xdjFhMSAxIDAgMCAxLTEuNDQ3Ljg5NWwtNC0yQTEgMSAwIDAgMSA2IDE2VjhhMSAxIDAgMCAxIC41NTMtLjg5NXpNNyA4djhsNCAyVjZ6bTkuMTQ3IDEuNjVhLjUuNSAwIDAgMSAuNzA3IDBsMiAyYS41LjUgMCAwIDEgMCAuNzA3bC0yIDJhLjUuNSAwIDAgMS0uNzA3LS43MDdsMS4xNDYtMS4xNDZIMTMuNWEuNS41IDAgMCAxIDAtMWgzLjc5M2wtMS4xNDYtMS4xNDctLjA2NS0uMDc4YS41LjUgMCAwIDEgLjA2NC0uNjI5IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=9676-46999
*/
const Icon24Signout = memo(function Icon24Signout(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M10.553 5.105A1 1 0 0 1 12 6v1h1a1 1 0 0 1 1 1v2.004a.5.5 0 0 1-1 0V8h-1v8h1v-1.996a.5.5 0 1 1 1 0V16a1 1 0 0 1-1 1h-1v1a1 1 0 0 1-1.447.895l-4-2A1 1 0 0 1 6 16V8a1 1 0 0 1 .553-.895zM7 8v8l4 2V6zm9.147 1.65a.5.5 0 0 1 .707 0l2 2a.5.5 0 0 1 0 .707l-2 2a.5.5 0 0 1-.707-.707l1.146-1.146H13.5a.5.5 0 0 1 0-1h3.793l-1.146-1.147-.065-.078a.5.5 0 0 1 .064-.629",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Signout };

//# sourceMappingURL=icon-24-signout.js.map